var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThanhtoan = function SvgThanhtoan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36602 22.9086H21.8803C22.2917 22.9086 22.6346 22.5657 22.6346 22.1543V5.35429L18.2803 1H6.31459C5.90316 1 5.5603 1.34286 5.5603 1.75429V3.16",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.526 15.9486V5.97144",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2802 1V5.01143C18.2802 5.21714 18.4516 5.35429 18.623 5.35429H22.6344",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1316 5.97148H4.60013C4.1887 5.97148 3.88013 5.62862 3.88013 5.25148V3.91434C3.88013 3.50291 4.22298 3.19434 4.60013 3.19434H14.1316C14.543 3.19434 14.8516 3.53719 14.8516 3.91434V5.25148C14.8516 5.66291 14.5087 5.97148 14.1316 5.97148Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77722 8.88574H19.4115",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77722 11.8H19.4115",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77722 14.6801H19.4115",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77722 17.5942H19.4115",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4114 20.4742H10.0857",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43433 20.7486L4.73718 22.2229L7.65147 18.7257",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52571 25C8.0252 25 10.0514 22.9738 10.0514 20.4743C10.0514 17.9748 8.0252 15.9486 5.52571 15.9486C3.02623 15.9486 1 17.9748 1 20.4743C1 22.9738 3.02623 25 5.52571 25Z",
    stroke: "#363C58",
    strokeMiterlimit: 10
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThanhtoan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thanhtoan.88bd7264.svg";
export { ForwardRef as ReactComponent };